import { DaneKlientaProfil } from "./daneKlientaProfil";

export class EdytujDaneKontaModel {
    imie: string;
    nazwisko: string;
    numerTelefonu: string;
}